import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";

export default function ToggleGalleryViewButton({ hide, on, onClick }) {
  if (hide) {
    return null;
  }

  return (
    <div
      aria-label={`${on ? "Hide" : "Show"} Slideshow Index`}
      className="nav__slideshow-index-toggle"
      onClick={onClick}
      onKeyUp={keyboardEventPassthroughHandler(onClick)}
      role="button"
      tabIndex={0}
    >
      <span
        className={classnames({
          "icon-Gallery": !on,
          "icon-Close2": on,
        })}
      />
    </div>
  );
}

ToggleGalleryViewButton.propTypes = {
  hide: PropTypes.bool,
  on: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
